import {
  ClientApp,
  ClientAppProps,
  initBugsnag,
  initPerformanceAnalytics,
} from '@stitch-fix/sf-next';
import { GraphQLApiProvider } from '../components/GraphQLApiProvider';

// Initialize Bugsnag error monitoring for your project.
// For configuration options, including how to debug locally, view guide at:
// https://github.com/stitchfix/sf-next/blob/beta/docs/bugsnag.md
initBugsnag();

// Initialize performance analytics for your project.
// For configuration options, including how to debug locally or increase
// the sample rate, view guide at:
// https://github.com/stitchfix/sf-next/blob/beta/docs/analytics.md
initPerformanceAnalytics({
  sampleRate: 60,
});

const App = (props: ClientAppProps) => {
  return <ClientApp {...props} GraphQLApiProvider={GraphQLApiProvider} />;
};

// Report on next.js metrics and mark `app_rendered`.
// AUTOGENERATED BY SF-NEXT TO SUPPORT TRACKING PERFORMANCE ANALYTICS.
// DO NOT REMOVE.
export { reportWebVitals } from '@stitch-fix/sf-next';

export default App;
